import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import MotivesActions from '../../Data/Redux/MotivesRedux'
import EnrollmentsCategoriesActions from '../../Data/Redux/EnrollmentsCategoriesRedux'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import Tool from '../../Components/ReportsComponents/Tool'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class Disenrollments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
      reasons: [],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getMotives, getEnrollmentsCategories } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'enrollments/motives')
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'enrollments/motives')
      }
    } else {
      getMotives()
    }
    getEnrollmentsCategories()
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { motives, enrollmentsCategories, fromCenter, centersInfo } = nextProps
    const newData = []
    const reasons = []
    if (motives && enrollmentsCategories.data) {
      Object.keys(motives).map((key) => {
        const item = { date: key, formatDay: moment(key).format('MMM YYYY') }
        let total = 0
        Object.keys(motives[key]).map((reason) => {
          if (motives[key][reason].category_id) {
            const category = enrollmentsCategories.data.find(cat => cat.id === motives[key][reason].category_id)
            if (!reasons.includes(category.name)) {
              reasons.push(
                category.name)
            }
            item[category.name] =
            motives[key][reason].total_enrollments
            total += motives[key][reason].total_enrollments
          } else {
            for (let i = 0; i < reasons.length; i++) {
              item[reasons[i]] = 0
            }
          }
        })
        item['total'] = total
        newData.push(item)
      })
      this.setState({ data: newData, reasons })
    }
    if (centersInfo && enrollmentsCategories.data) {
      Object.keys(centersInfo).map((key) => {
        const item = { date: key, formatDay: moment(key).format('MMM YYYY') }
        let total = 0
        Object.keys(centersInfo[key]).map((reason) => {
          if (centersInfo[key][reason].category_id) {
            const category = enrollmentsCategories.data.find(cat => cat.id === centersInfo[key][reason].category_id)
            if (!reasons.includes(category.name)) {
              reasons.push(
                category.name)
            }
            item[category.name] =
            centersInfo[key][reason].total_enrollments
            total += centersInfo[key][reason].total_enrollments
          } else {
            for (let i = 0; i < reasons.length; i++) {
              item[reasons[i]] = 0
            }
          }
        })
        item['total'] = total
        newData.push(item)
      })
      this.setState({ data: newData, reasons })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  filter = ({ currentTarget: { id: reason } }) => {
    const newState = { ...this.state }
    const { motives, enrollmentsCategories } = this.props
    for (let i = 0; i < newState.data.length; i++) {
      if (newState.data[i][reason] && (newState.data[i][reason] !== 0 &&  newState.data[i][reason] !== null)) {
        newState.data[i][reason] = null
        const { date } = newState.data[i]
        const enrollment = motives[date]
        Object.keys(enrollment).map((key) => {
          const category = enrollmentsCategories.data.find(cat => cat.name === reason)
          const selectedEnrollment = enrollment.find(e => e.category_id === category.id)
          if (category.name === reason) {
            newState.data[i]['total'] -= selectedEnrollment.total_enrollments
          }
        })
      } else if (newState.data[i][reason] === 0 || newState.data[i][reason] === null) {
        const { date } = newState.data[i]
        const enrollment = motives[date]
        Object.keys(enrollment).map((key) => {
          const category = enrollmentsCategories.data.find(cat => cat.name === reason)
          const selectedEnrollment = enrollment.find(e => e.category_id === category.id)
          if (category.name === reason) {
            newState.data[i]['total'] += selectedEnrollment.total_enrollments
            newState.data[i][reason] = selectedEnrollment.total_enrollments
          }
        })
      }
    }
    this.setState(newState)
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] && (this.state.data[i][name] !== 0 && this.state.data[i][name] !== null)) {
        count++
      }
    }
    return count > 0
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('enrollments/motives', this.props.activeCenter)
    } else {
      this.props.getMotivesExcel()
    }
  }

  renderOptions = () => {
    const reasonsToRender = this.state.reasons.map((reason, index) => {
      return (
        <Bar key={index} stackId="a" dataKey={reason} fill={this.pickColor(reason) ? COLORS[index % COLORS.length] : 'gray'} />
      )
    })
    return (
      reasonsToRender
    )
  }

  render() {
    const { fromCenter } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title="Altas/Motivo"
        date={data[0] &&
          { initial: data[0].date, end: data[data.length - 1].date }}
        onClick={this.download}
        loading={!data[0]}
      >
        {data[0] &&
          <BarChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="formatDay" />
            <YAxis />
            <Tooltip content={<Tool withoutCurrency />} />
            <Legend content={<CustomizedLegend onClick={!fromCenter && this.filter} />} />
            {this.renderOptions()}
          </BarChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ motives, enrollmentsCategories, centersInfo }) => ({
  motives: motives.get.results,
  enrollmentsCategories: enrollmentsCategories.get.results,
  centersInfo: centersInfo.motives.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getMotives: () => dispatch(MotivesActions.getRequest({}, true)),
  getEnrollmentsCategories: () => dispatch(EnrollmentsCategoriesActions.getRequest({}, true)),
  getMotivesExcel: () => dispatch(MotivesActions.MotivesExcelRequest()),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Disenrollments))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Motives.jsx